import { render, staticRenderFns } from "./VgcCasePikcer.vue?vue&type=template&id=edcaa998&scoped=true"
import script from "./VgcCasePikcer.vue?vue&type=script&lang=js"
export * from "./VgcCasePikcer.vue?vue&type=script&lang=js"
import style0 from "./VgcCasePikcer.vue?vue&type=style&index=0&id=edcaa998&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edcaa998",
  null
  
)

export default component.exports